import { Capacitor } from "@capacitor/core";
import { app, db } from "./firebase";
import { doc, updateDoc } from "firebase/firestore";

export const initFCM = async (userId) => {
  if (!userId) return;
  try {
    if (Capacitor.isNativePlatform()) {
      const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");
      await FirebaseMessaging.requestPermissions();
      const { token } = await FirebaseMessaging.getToken();
      if (token) {
        await updateDoc(doc(db, "users", userId), { fcmToken: token });
      }
      FirebaseMessaging.addListener("notificationReceived", () => {});
    } else {
      const { getMessaging, getToken, onMessage, isSupported } = await import("firebase/messaging");
      const supported = await isSupported();
      if (!supported) return;
      const permission = await Notification.requestPermission();
      if (permission !== "granted") return;
      const messaging = getMessaging(app);
      const token = await getToken(messaging, {
        vapidKey: "BN9sE6hu9LbGwVdMfkFea83AhiAZrWJAmojV71ViEJbY4ecJowBkfxJWCQjqmUu62DhrHsTjAc6ABevuL9ywQ20"
      });
      if (token) {
        await updateDoc(doc(db, "users", userId), { fcmToken: token });
      }
      onMessage(messaging, (payload) => {
        if (payload.notification) {
          new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: "/logo192.png"
          });
        }
      });
    }
  } catch (error) {
    console.error("FCM init error:", error);
  }
};